setInterval(() => {
    const randomNumber = getRandomInt(15);
    if (randomNumber === 0) {
        sendGhost();
    }
}, 1000);

function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}

const sendGhost = () => {
    const ghostWrapper = document.createElement("div");
    ghostWrapper.style.pointerEvents = "none";
    ghostWrapper.style.position = "fixed";
    ghostWrapper.style.zIndex = 9999;
    ghostWrapper.style.transition = "transform 2.5s linear"; 
    const ghost = document.createElement("img");
    ghost.src = "https://cdn.shopify.com/s/files/1/0353/7249/files/Ghost.png?v=1758888994"
    ghostWrapper.appendChild(ghost);
    ghost.style.height="200px"
    ghost.style.width="200px"

    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const startX = Math.random() * (screenWidth - 50);
    ghostWrapper.style.left = startX + "px";
    ghostWrapper.style.bottom = "-50px";
    document.body.appendChild(ghostWrapper);

    const travelY = -(screenHeight + 100); 
    const angle = 20 * Math.PI / 180; 
    const travelX = Math.tan(angle) * Math.abs(travelY);

    requestAnimationFrame(() => {
        ghostWrapper.style.transform = `translate(${travelX}px, ${travelY}px)`;
    });

    setTimeout(() => {
        ghostWrapper.remove();
    }, 3000);
};
